export const info = {
  heights: {
    large: {
      default: 480,
      smallTablet: 600,
      smallDesktop: 692,
    },
    medium: {
      default: 480,
      smallTablet: 542,
      smallDesktop: 602,
    },
    small: {
      default: 340,
    },
  },
} as const;
